import React from "react";
import AdSense from "react-adsense";
const AdSence = () => {
    return (
        <>
            <AdSense.Google
                client="pub-1981644791158869"
                slot="9572457820"
                style={{ display: "block" }}
                layout="in-article"
                format="fluid"
            />
        </>
    );
};

export default AdSence;
